import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledTypography = styled.div`
  // min-height: 35px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -moz-box-orient: vertical;
  line-height: 27px !important;
  border-bottom: 2px solid #e0e0e0;
  padding: 20px;
  margin-bottom: 20px;
  & > span {
    color: #535353;
  }
  & > div > span {
    color: #535353;
  }
`;

export const StyledTypographyUser = styled.div`
  // min-height: 35px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -moz-box-orient: vertical;
  background: linear-gradient(150deg, #00a2cc, #04c1f3);
  display: inline-block;
  width: auto;
  max-width: 80%;
  min-width: 160px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-bottom-right-radius: 0px;
  line-height: 27px !important;
  // border-bottom: 2px solid #e0e0e0;
  padding: 10px;
  padding-bottom: 26px;
  position: relative;
  right: 6px;
  color: white;
  & > .date {
    position: absolute;
    right: 8px;
    bottom: 0px;
    font-size: 11px;
  }
  & > .file {
    display: flex;
    align-items: center;
  }
  & > .file > a {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      font-size: 27px;
    }
  }
  & > .file > span {
    display: flex;
    flex-direction: column;
  }
  & > .arrow {
    border-top: 7px solid transparent;
    border-left: 7px solid #04c1f3;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #04c1f3;
    position: absolute;
    right: -11px;
    bottom: 0;
  }
`;

export const StyledTypographyAdmin = styled.div`
  // min-height: 35px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // -moz-box-orient: vertical;
  background: linear-gradient(30deg, ${theme.palette.primary.light}, #b0eeff);
  display: inline-block;
  width: auto;
  max-width: 80%;
  min-width: 160px;
  margin-bottom: 10px;
  margin-left: 10px;
  border-radius: 20px;
  border-bottom-left-radius: 0px;
  line-height: 27px !important;
  // border-bottom: 2px solid #e0e0e0;
  padding: 10px;
  padding-bottom: 26px;
  position: relative;
  left: 6px;
  color: black;
  & > .date {
    position: absolute;
    left: 8px;
    bottom: 0px;
    font-size: 11px;
  }
  & > .file {
    display: flex;
    align-items: center;
  }
  & > .file > a {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      font-size: 27px;
    }
  }
  & > .file > span {
    display: flex;
    flex-direction: column;
  }
  & > .arrow {
    border-top: 7px solid transparent;
    border-left: 7px solid transparent;
    border-right: 7px solid ${theme.palette.primary.light};
    border-bottom: 7px solid ${theme.palette.primary.light};
    position: absolute;
    left: -10px;
    bottom: 0;
  }
`;

export const StyledContainerBox = styled.div`
  width: 100% !important;
  position: relative !important;
  & .MuiOutlinedInput-root label,
  & .MuiOutlinedInput-root div,
  & .MuiOutlinedInput-root input,
  & .MuiOutlinedInput-root fieldset {
    opacity: 0 !important;
  }
`;
export const StyledUploadBox = styled.div`
  width: 100% !important;
  height: 100% !important;
  color: ${(props) =>
    props.file ? (props.error ? "#d32f2f" : "black") : "rgba(0, 0, 0, 0.6)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px solid
    ${(props) => (props.error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)")};
  border-radius: 5px;
  padding: 5.1px 14px;
  & svg {
    color: ${theme.palette.primary.main};
    font-size: 24px;
    margin: 0px !important;
    padding: 0px !important;
  }
`;
export const StyledChoiceFileText = styled.span`
  max-width: 100% !important;
  color: #333 !important;
  font-size: 17px !important;
  margin: 0px !important;
  padding: 0px !important;
`;
